<script lang="ts">
  import { Label } from "$lib/components/ui/label";
  import { Button } from "$lib/components/ui/button";
  import { type ImageType } from "@briefmarken_katalog/types";
  import QRUploadDialog from "./QRUploadDialog.svelte";
  import Picture from "../Picture.svelte";
  import { t } from "$lib/i18n";

  const { pictures, handleImageUpload, onPhoneUpload, onRemove, isReadonly = false } = $props<{
    pictures: ImageType[];
    handleImageUpload: (e: Event) => void;
    onPhoneUpload?: (picture: ImageType) => void;
    onRemove: (index: number) => void;
    isReadonly?: boolean;
  }>();

  let fileInput = $state<HTMLInputElement | undefined>(undefined);
  let qrOpen = $state(false);
</script>

<div class="grid grid-cols-4 items-start gap-4">
  <Label class="text-right pt-2">{$t('fields.photoScan')}</Label>
  <div class="col-span-3 flex flex-col gap-2">
    {#if pictures.length > 0}
      <div class="flex flex-wrap gap-3">
        {#each pictures as picture, i}
          <div class="relative">
            <Picture {picture}/>
            {#if !isReadonly}
              <button
                type="button"
                class="absolute -top-1.5 -right-1.5 bg-red-500 hover:bg-red-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs leading-none cursor-pointer"
                onclick={() => onRemove(i)}
                title={$t('upload.removePhoto')}
              >×</button>
            {/if}
          </div>
        {/each}
      </div>
    {/if}
    {#if !isReadonly}
      <div class="flex flex-wrap gap-2">
        <input
          bind:this={fileInput}
          type="file"
          accept="image/*"
          onchange={handleImageUpload}
          class="hidden"
        />
        <Button variant="outline" onclick={() => fileInput?.click()}>
          {$t('upload.addPhoto')}
        </Button>
        {#if onPhoneUpload}
          <Button variant="outline" onclick={() => qrOpen = true}>{$t('upload.button')}</Button>
        {/if}
      </div>
    {/if}
  </div>
</div>

{#if onPhoneUpload}
  <QRUploadDialog bind:open={qrOpen} onPictureReceived={onPhoneUpload}/>
{/if}
